/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
let n=null;function t(t){n=t}function u(){return n}export{u as getLoader,t as registerLoader};
